/* this file is transformed by vux-loader */
/* eslint-disable */
var actions = {
  actionFoodList: function actionFoodList(_ref, foodList) {
    var commit = _ref.commit;
    return commit('mutationFoodList', foodList);
  }
};
export default actions;